import { Fragment, useEffect, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";

const noop = () => {};

export default function PeopleOverlay({ isOpen = false, person = null, onClose = noop }) {
  const [activePerson, setActivePerson] = useState(person);

  useEffect(() => {
    if (person) {
      setActivePerson(person);
    }
  }, [person]);

  const hasContent = Boolean(
    activePerson &&
      (activePerson.name ||
        activePerson.jobTitle ||
        activePerson.locationHTML ||
        activePerson.bioHTML ||
        activePerson.imageHTML)
  );

  return (
    <Transition
      show={isOpen && hasContent}
      as={Fragment}
      appear
      afterLeave={() => setActivePerson(null)}
    >
      <Dialog as="div" className="b-people__overlay" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-smooth duration-500"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-smooth duration-500"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="b-people__overlay-backdrop" aria-hidden="true" />
        </Transition.Child>

        <div className="b-people__overlay-wrapper">
          <Transition.Child
            as={Fragment}
            enter="ease-smooth duration-500"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-smooth duration-500"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <Dialog.Panel className="b-people__overlay-panel">
              <button
                type="button"
                className="b-people__overlay-close"
                onClick={onClose}
                aria-label="Close details"
              >
                <span aria-hidden="true">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="15"
                    fill="none"
                    viewBox="0 0 16 15"
                  >
                    <path stroke="#000" strokeWidth="2" d="m1.119.707 13.435 13.435M14.142.707.707 14.142" />
                  </svg>
                </span>
              </button>

              {activePerson?.imageHTML ? (
                <div className="b-people__overlay-picture">
                  <div
                    className="b-people__overlay-picture-inner"
                    dangerouslySetInnerHTML={{ __html: activePerson.imageHTML }}
                  />
                </div>
              ) : null}

              <div className="b-people__overlay-text">

                {activePerson?.name ? (
                  <Dialog.Title className="b-people__overlay-name">{activePerson.name}</Dialog.Title>
                ) : null}

                {activePerson?.jobTitle ? (
                  <span className="b-people__overlay-position">{activePerson.jobTitle}</span>
                ) : null}

                {activePerson?.locationHTML ? (
                  <span
                    className="b-people__overlay-location"
                    dangerouslySetInnerHTML={{ __html: activePerson.locationHTML }}
                  />
                ) : null}

                {activePerson?.bioHTML ? (
                  <div
                    className="b-people__overlay-bio"
                    dangerouslySetInnerHTML={{ __html: activePerson.bioHTML }}
                  />
                ) : null}
              </div>
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
}
